import { createActionTypes } from 'sdk/base';

export const sliceName = 'firebaseApi';
export const ActionTypes = createActionTypes([
    'FB_IS_updateIndicator',
    'UPDATE_MESSAGES',
    'UPDATE_LANG'
]);

const config = {
    sliceName
};

export const firebaseAuthentication = {
    apiKey: 'AIzaSyDFoTCecH20roeCxrYv7CgnPEqwvK8VPkw',
    authDomain: 'appna-blog.firebaseapp.com',
    databaseURL: 'https://appna-blog-default-rtdb.asia-southeast1.firebasedatabase.app',
    projectId: 'appna-blog',
    storageBucket: 'appna-blog.firebasestorage.app',
    messagingSenderId: '131169314149',
    appId: '1:131169314149:web:1f326519d9f27533b06d8c',
    measurementId: 'G-C784FWFSH6'
};

export const FIREBASE_TABLES = {
    USERS: 'Users',
    BLOGS: 'Blogs'
};
export default config;
